import { Divider, ListItem, Typography } from "@mui/material";
import { AppImages } from "assets/appResources";
import { GridEx } from "components/MuiExtras/Grid/GridEx";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import MuiReverse from "components/MuiExtras/Typography/MuiReverse";
import { TextPluralization } from "components/TextPluralization";
import AppResource from "components/Translations/AppResources";
import HtmlUtils from "lib/HtmlUtils";
import { GlobalSearchItem } from "models/ApiModels";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { RoutePaths } from "routes/RouteConfig";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: GlobalSearchItem;
    index: number;
    showDivider: boolean;
}

type Props = IProps & RouteComponentProps<{}>;

/////////////////////////////////////////////////////////////////////////////////////////////////

export const SearchRenderCourse: React.FC<Props> = (props) => {

    const { data, index, showDivider } = props;

    return (
        <React.Fragment key={"seachItem-" + index}>
            <ListItem
                button
                onClick={
                    () => {
                        if (!data.enrolled) {
                            props.history.push(RoutePaths.TimelineCourses, { id: data.id });
                        }
                        else {
                            HtmlUtils.openUrlInNewWindow(RoutePaths.PublicationCourseViewer.replace(":id", data.id));
                        }
                    }
                }
            >
                <GridEx container wrap="nowrap" spacing={1} >
                    <GridEx item>
                        <img src={data.thumbnailUrl ?? AppImages.PublicationTypeCourseThumbnail} alt={data.title} width="48" />
                    </GridEx>
                    <GridEx item xs>
                        <div>
                            <Typography color="secondary" variant="body1">{data.title}</Typography>
                        </div>
                        <MuiMuted>
                            <Typography variant="caption">
                                <AppResource resource="Common.Literals.CourseText" />
                                <span> &ndash;</span>
                                <span> <TextPluralization count={data.totalViews} resource="Views.Search.Components.SearchRenderCourse.SubscriptionText" /></span>
                                {data.enrolled ? <span> &ndash; <MuiReverse color="warning"><AppResource resource="Views.Search.Components.SearchRenderCourse.EnrolledText" /></MuiReverse></span> : null}
                            </Typography></MuiMuted>
                    </GridEx>
                </GridEx>
            </ListItem>
            {showDivider && <Divider />}
        </React.Fragment>
    );
};